import { defineMessages } from 'react-intl';

const messages = defineMessages({
  introduction: {
    id: 'MarketVideo.introduction',
    defaultMessage: 'What is Sorare',
  },
  getStarted: {
    id: 'MarketVideo.getStarted',
    defaultMessage: 'Get Started',
  },
  scoring: {
    id: 'MarketVideo.scoring',
    defaultMessage: 'Scoring System',
  },
  competitions: {
    id: 'MarketVideo.competitions',
    defaultMessage: 'Competitions',
  },
});

export const marketVideo = {
  key: 'market',
  en: {
    src: 'https://www.youtube.com/embed/Ibi_7vUWHNA?si=bwfyZZzQTGioZZoJ&autoplay=1',
    thumbnail: 'https://img.youtube.com/vi/Ibi_7vUWHNA/hqdefault.jpg',
  },
};

export const introductionVideo = {
  key: 'introduction',
  en: {
    src: 'https://www.youtube.com/embed/RVsgESV0uvo?si=2TiIxjB051hvotGw&autoplay=1',
    thumbnail: 'https://img.youtube.com/vi/RVsgESV0uvo/hqdefault.jpg',
    title: messages.introduction,
  },
};

export const getStartedVideo = {
  key: 'getStarted',
  en: {
    src: 'https://www.youtube.com/embed/Q30ajmX4zfg?si=sXugmcL5R4WFwrQt&autoplay=1',
    thumbnail: 'https://img.youtube.com/vi/Q30ajmX4zfg/hqdefault.jpg',
    title: messages.getStarted,
  },
};

export const scoringVideo = {
  key: 'scoring',
  en: {
    src: 'https://www.youtube.com/embed/1PVU7ldJSDM?si=noZvVDatrJICyv73&autoplay=1',
    thumbnail: 'https://img.youtube.com/vi/1PVU7ldJSDM/hqdefault.jpg',
    title: messages.scoring,
  },
};

export const competitionsVideo = {
  key: 'competitions',
  en: {
    src: 'https://www.youtube.com/embed/ewjdbFZ5yIk?si=Jec4Y3UkSAAxNzug&autoplay=1',
    thumbnail: 'https://img.youtube.com/vi/ewjdbFZ5yIk/hqdefault.jpg',
    title: messages.competitions,
  },
};
